import { StyleSheet, Image, Platform, useWindowDimensions, Pressable } from 'react-native'
import React, { useMemo } from 'react'
import { DS } from '../../design-system'
import HoverCode from '../../assets/hovercode.png'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const ShareGameQR = ({ onPress }: { onPress: () => void }) => {
  const insets = useSafeAreaInsets()
  const { height } = useWindowDimensions()
  const extraPaddingBottom = Platform.OS === 'android' ? DS.spacing['24'] : DS.spacing['12']
  const isSmallDevice = useMemo(() => height < 730, [height])

  return (
    <Pressable onPress={onPress}>
      <DS.Frame
        style={[styles.container, { paddingBottom: insets.bottom + extraPaddingBottom }]}
        gap={isSmallDevice ? '12' : '24'}
      >
        <DS.Frame style={styles.handle} />
        <DS.Frame row justifyContent="space-between" alignItems="center">
          <DS.Frame gap="8">
            <DS.Text variant="Heading 3/Medium" color="Global/White">
              Share Game QR
            </DS.Text>
            <DS.Text variant="Body Small/Regular" color="Global/White">
              Near people now? Scan to join
            </DS.Text>
          </DS.Frame>
          <Image source={HoverCode} style={styles.qr} />
        </DS.Frame>
      </DS.Frame>
    </Pressable>
  )
}

export default ShareGameQR

const styles = StyleSheet.create({
  container: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    backgroundColor: `${DS.palette['Global/White']}10`,
    paddingHorizontal: DS.spacing['24'],
    paddingTop: 4,
    marginHorizontal: 32
  },
  handle: {
    width: 36,
    height: 4,
    borderRadius: 4,
    backgroundColor: `${DS.palette['Global/White']}80`,
    alignSelf: 'center',
    marginTop: DS.spacing['8']
  },
  qr: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: `${DS.palette['Global/White']}80`
  }
})
